export const API_KEY = "AIzaSyCEp_I00jPaVvw7FUBWXMz4hsmxvEJlcEA"
export default API_KEY